import { Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import suppliesApi from "../../../constants/suppliesApi";
import { toast } from "react-toastify";

const CreateModal = ({ open, hide, setData, data, id, t }) => {
  const [name, setName] = useState("");
  const [type, setType] = useState({ id: "", name: "" });
  const [services, setServices] = useState({ id: "", name: "" });
  const [identification, setIdentification] = useState("");

  useEffect(() => {
    if (id) {
      trackPromise(
        suppliesApi
          .getProvidersById(localStorage.getItem("GlobalCustomerId"), id)
          .then((json) => {
            setName(json.name);
            setIdentification(json.identification);
            setServices(json.services);
            setType(json.provider_type);
          })
          .catch((err) => {
            toast.error(err.response.data.detail);
          })
      );
    }
  }, [id]);

  const createOrEditProvider = () => {
    const body = {
      client: {
        id: localStorage.getItem("GlobalCustomerId"),
        name: localStorage.getItem("GlobalCustomerName"),
      },
      name,
      provider_type: type,
      identification: identification,
      services: services,
    };

    if (id) {
      trackPromise(
        suppliesApi
          .updateProvidersById(id, body)
          .then((json) => {
            toast.success(t("providers.provider-item-10"));
            hide();
            data.findIndex((elemento, indice) => {
              if (elemento.id === json.id) {
                data.splice(indice, 1, json);
              }
            });
            setData([...data]);
          })
          .catch((err) => {
            toast.error(err.response.data.detail);
          })
      );
    } else {
      trackPromise(
        suppliesApi
          .createProvider(body)
          .then((json) => {
            toast.success(t("providers.provider-item-11"));
            hide();
            setData([...data, json]);
          })
          .catch((err) => {
            toast.error(err.response.data.detail);
          })
      );
    }
  };

  return (
    <Modal show={open} dialogClassName="modal-sm-providers" onHide={hide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {id
            ? t("providers.provider-item-12")
            : t("providers.provider-item-13")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="form-group">
            <label>
              <span className="text-danger">*</span>
              {t("providers.provider-item-14")}
            </label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={name}
              placeholder="Nombre"
              required
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>ID/NIT</label>
            <input
              type="text"
              name="id_nit"
              className="form-control"
              placeholder="ID/NIT"
              value={identification}
              onChange={(e) => setIdentification(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>{t("providers.provider-item-5")}</label>
            <select
              className="form-control"
              type="text"
              name="provider_type"
              value={type.id}
              onChange={(e) =>
                setType({
                  id: e.target.value,
                  name: e.target.options[e.target.selectedIndex].text,
                })
              }
            >
              <option value={null}>{t("providers.provider-item-15")}</option>
              <option value={1}>{t("providers.provider-item-16")}</option>
              <option value={2}>{t("providers.provider-item-17")}</option>
              <option value={3}>{t("providers.provider-item-18")}</option>
            </select>
          </div>
          <div className="form-group">
            <label>{t("providers.provider-item-16")}</label>
            <select
              className="form-control"
              type="text"
              name="services"
              value={services.id}
              onChange={(e) =>
                setServices({
                  id: e.target.value,
                  name: e.target.options[e.target.selectedIndex].text,
                })
              }
            >
              <option value={null}>{t("providers.provider-item-15")}</option>
              <option value={1}>{t("providers.provider-item-19")}</option>
              <option value={2}>{t("providers.provider-item-20")}</option>
            </select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-outline-primary" onClick={hide}>
          {t("providers.provider-item-21")}
        </button>
        <button
          className="btn btn-primary"
          onClick={() => {
            createOrEditProvider();
          }}
          disabled={name.length ? false : true}
        >
          {id
            ? t("providers.provider-item-8")
            : t("providers.provider-item-22")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateModal;
